import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import RibbonAlmamaterVisit from './ribbon'
import ImportAlmamaterVisit from './import'
import AlmamaterVisitMemberDetail from './detail'
import FilterAlmamaterVisit from './filter'

export default function AlmamaterVisitMember() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [memberData, setMemberData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isImportVisible, setIsImportVisible] = useState(false)
  const [isDetailVisible, setIsDetailVisible] = useState(false)

  const initialConditions = {
    category: '',
    team: '',
    keywords: ''
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getMemberData = () => {
    axios.post('/p/almamater_visit/member/list/get', { 
      merchant_oid: merchantOid,
      category_oid: filterValue.category,
      team_oid: filterValue.team,
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setMemberData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'members': response.data.members
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  useEffect(() => {
    getMemberData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, filterValue, currentPage])

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">成员行程</div>
            <RibbonAlmamaterVisit 
              filterValue={filterValue} 
              setFilterValue={setFilterValue}
              isImportVisible={() => { setIsImportVisible(true) }}
            />
        </div>

        <FilterAlmamaterVisit 
          filterValue={filterValue} 
          setFilterValue={setFilterValue}
          setCurrentPage={setCurrentPage}
        />

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>姓名</th>
                <th>手机号</th>
                <th>所属团队</th>
                <th>所属分类</th>
              </tr>
            </thead>

            <tbody>
              {memberData.members && (memberData.members.length > 0 ? (memberData.members.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.name}</td>
                  <td>{item.phone}</td>
                  <td>{item.team}</td>
                  <td>{item.category}</td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="7"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={memberData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>
      </div>

      {isImportVisible && <ImportAlmamaterVisit
        filterValue={filterValue} 
        getMemberData={getMemberData}
        isOpen={isImportVisible}
        isCancel={() => { setIsImportVisible(false) }}
      />}

      {isDetailVisible && <AlmamaterVisitMemberDetail
        data={propsData}
        isOpen={isDetailVisible}
        isCancel={() => { setIsDetailVisible(false) }}
      />}
    </div>
  )
}
